import { Button } from 'component/Button'
import { Spinner } from 'component/Spinner'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { NameInput } from 'page/catalog/UserModal/step/NameInput'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'

export const EditStep = observer(() => {
  const store = userModal.it
  const { busy } = store

  const onRef = useLatestCallback((root: HTMLDivElement | null) => {
    if (!root) return
    const focus = root.querySelector('input')
    focus?.focus()
  })

  const onSave = useLatestCallback(async () => {
    await store.save()
  })

  return <Vertical ref={onRef} gap={16}>
    <NameInput />
    <Button gap={8} height={48} primary action={onSave}>
      {busy ? <Spinner size={16} white /> : null}
      <Typo>{i18n('Save')}</Typo>
    </Button>
  </Vertical>
})
